import { useEffect } from 'react'
import { type KlarnaOrder } from 'ecosystem'
import { KlarnaCheckout } from '../KlarnaCheckout'

type KlarnaConfirmationProps = {
  klarnaData: KlarnaOrder
  onConfirmPurchase: () => void
}

export const KlarnaConfirmation = ({ klarnaData, onConfirmPurchase }: KlarnaConfirmationProps) => {
  useEffect(() => {
    if (!klarnaData) {
      return
    }

    onConfirmPurchase()
  }, [klarnaData, onConfirmPurchase])

  if (!klarnaData) {
    return null
  }

  return <KlarnaCheckout klarnaData={klarnaData} />
}
